// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module--container--1mM6a","paragraph":"style-module--paragraph--1sAXz","title":"style-module--title--ozf6S"};